(function() {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  function getTemplate() {
    var mainEl = document.querySelector('main[data-template]');
    if (mainEl) return mainEl.getAttribute('data-template');
    var bodyTpl = document.body.getAttribute('data-template');
    if (bodyTpl) return bodyTpl;
    var p = window.location.pathname;
    if (p === '/' || p === '') return 'index';
    if (/^\/products\//.test(p)) return 'product';
    if (/^\/collections\/[^/]+/.test(p)) return 'collection';
    if (/^\/collections\/?$/.test(p)) return 'list-collections';
    return null;
  }

  function getProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? m[1].toLowerCase() : '';
  }

  function tagBody() {
    var tpl = getTemplate();
    if (tpl && !document.body.classList.contains('dmk-tpl-' + tpl)) {
      document.body.classList.add('dmk-tpl-' + tpl);
    }
    if (tpl === 'collection') {
      var match = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
      if (match && match[1] && !document.body.classList.contains('dmk-coll-' + match[1])) {
        document.body.classList.add('dmk-coll-' + match[1]);
      }
    }
    return tpl;
  }

  tagBody();

  var sectionObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dmk-in-view');
        sectionObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

  var staggerObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dmk-revealed');
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

  var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var duration = parseInt(el.getAttribute('data-duration') || '1600', 10);
    var start = performance.now();
    function tick(now) {
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var current = (target * eased).toFixed(decimals);
      el.textContent = decimals > 0 ? current : Math.floor(target * eased).toLocaleString();
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = decimals > 0 ? target.toFixed(decimals) : target.toLocaleString();
    }
    requestAnimationFrame(tick);
  }

  function injectStatsBand() {
    if (document.querySelector('.dmk-stats-band')) return;
    var marquee = document.querySelector('.shopify-section[id*="dmk_marquee_band"]');
    if (!marquee) return;
    var band = document.createElement('section');
    band.className = 'dmk-stats-band dmk-fade-in';
    band.innerHTML = ''
      + '<div class="dmk-stat-item"><div class="dmk-stat-value"><span class="dmk-stat-num" data-target="4.8" data-decimals="1">0</span><span class="dmk-stat-suffix">★</span></div><div class="dmk-stat-label">Average rating</div></div>'
      + '<div class="dmk-stat-item"><div class="dmk-stat-value"><span class="dmk-stat-num" data-target="1400">0</span><span class="dmk-stat-suffix">+</span></div><div class="dmk-stat-label">Happy customers</div></div>'
      + '<div class="dmk-stat-item"><div class="dmk-stat-value"><span class="dmk-stat-num" data-target="13">0</span></div><div class="dmk-stat-label">Cardigan styles</div></div>'
      + '<div class="dmk-stat-item"><div class="dmk-stat-value"><span class="dmk-stat-num" data-target="100">0</span><span class="dmk-stat-suffix">%</span></div><div class="dmk-stat-label">Hand-knit, no machines</div></div>';
    marquee.parentNode.insertBefore(band, marquee.nextSibling);
    sectionObserver.observe(band);
    band.querySelectorAll('.dmk-stat-num').forEach(function(el) { counterObserver.observe(el); });
  }

  function injectHandKnitPromise() {
    if (document.querySelector('.dmk-handknit-promise')) return;
    var story = document.querySelector('.shopify-section[id*="dmk_story_band"]');
    if (!story) return;
    var band = document.createElement('section');
    band.className = 'dmk-handknit-promise dmk-fade-in';
    band.innerHTML = ''
      + '<div class="dmk-handknit-promise__inner">'
      + '  <div class="dmk-handknit-promise__mark">⚜</div>'
      + '  <h2 class="dmk-handknit-promise__title">100% Hand-Knit.<br><em>By Hand. Stitch by Stitch.</em></h2>'
      + '  <p class="dmk-handknit-promise__body">Every single piece in our shop is knit by hand by the women of Daly Village in Türkiye. No machines. No mass production. Just wool, hands, and time.</p>'
      + '</div>';
    story.parentNode.insertBefore(band, story);
    sectionObserver.observe(band);
  }

  // Find a target AFTER the description/details where badges should sit
  function findBadgeTarget() {
    // Pick the last visible block in the product info column — below description / add-to-cart
    var candidates = [
      'product-description',
      '.product-description',
      '[class*="product-description"]',
      '.product-information__description',
      'buy-buttons-component',
      '[class*="buy-buttons"]'
    ];
    var found = null;
    for (var i = 0; i < candidates.length; i++) {
      var els = document.querySelectorAll(candidates[i]);
      for (var j = 0; j < els.length; j++) {
        if (els[j].offsetWidth > 0) { found = els[j]; break; }
      }
      if (found) break;
    }
    return found;
  }

  function ensureBadgeStrip() {
    var strip = document.querySelector('.dmk-product-meta-strip');
    if (strip) return strip;
    var anchor = findBadgeTarget();
    if (!anchor) return null;
    strip = document.createElement('div');
    strip.className = 'dmk-product-meta-strip';
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    return strip;
  }

  function injectProductHandKnitBadge() {
    if (document.querySelector('.dmk-product-handknit')) return;
    var strip = ensureBadgeStrip();
    if (!strip) return;
    var badge = document.createElement('div');
    badge.className = 'dmk-product-handknit';
    badge.innerHTML = '<span class="dmk-product-handknit__mark">⚜</span><span class="dmk-product-handknit__text"><strong>100% Hand-Knit</strong><span class="dmk-product-handknit__sub">By the women of Daly Village, Türkiye</span></span>';
    strip.appendChild(badge);
  }

  // Dispatch badge. All wording must match the official Shipping Policy:
  // everything dispatches within 2–7 days; only custom measurements take 4–6 weeks.
  function injectPreparationBadge() {
    if (document.querySelector('.dmk-prep-badge')) return;
    var strip = ensureBadgeStrip();
    if (!strip) return;

    var handle = getProductHandle();
    var isFox = /fox-cardigan|hail-mary/.test(handle);
    var isKnitToOrder = /weasley|monogram/.test(handle);

    var label, icon = '✈';
    if (isFox) {
      label = '<strong>In stock · ships in 2–7 days</strong>';
    } else if (isKnitToOrder) {
      label = '<strong>Knit to order · ships in 2–7 days</strong>';
    } else {
      label = '<strong>Ready · ships in 2–7 days</strong>';
    }

    var badge = document.createElement('div');
    badge.className = 'dmk-prep-badge dmk-prep-badge--compact';
    badge.innerHTML = '<span class="dmk-prep-badge__icon">' + icon + '</span><span class="dmk-prep-badge__line">' + label + '</span>';
    strip.appendChild(badge);
  }

  function injectProductProofStrip() {
    if (document.querySelector('.dmk-product-proof-strip')) return;
    var recs = document.querySelector('.shopify-section[id*="product_recommendations"]');
    var jdgm = document.querySelector('.shopify-section[id*="judge_me_reviews"]') || document.querySelector('[class*="jdgm-rev-widg"]');
    var anchor = recs || jdgm;
    if (!anchor) return;
    var strip = document.createElement('div');
    strip.className = 'dmk-product-proof-strip dmk-fade-in';
    strip.innerHTML = ''
      + '<div class="dmk-proof-item"><span class="dmk-proof-stars">★★★★★</span> <span><strong>4.8</strong> from <strong>1,400+</strong> Etsy reviews</span></div>'
      + '<div class="dmk-proof-divider"></div>'
      + '<div class="dmk-proof-item"><span class="dmk-proof-mark">⚜</span> <span><span class="dmk-proof-italic">Hand-knit,</span> never machine-made</span></div>'
      + '<div class="dmk-proof-divider"></div>'
      + '<div class="dmk-proof-item"><span class="dmk-proof-mark">⛰</span> <span>From <span class="dmk-proof-italic">Daly Village,</span> Türkiye</span></div>';
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    sectionObserver.observe(strip);
  }

  function italicizeLastWord() {
    var firstSection = document.querySelector('main .shopify-section');
    if (!firstSection) return;
    var h1 = firstSection.querySelector('h1');
    if (!h1 || h1.dataset.dmkItalicized) return;
    var text = h1.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    if (words.length < 2) return;
    var lastWord = words.pop();
    var rest = words.join(' ');
    h1.innerHTML = rest + ' <span class="dmk-italic-word">' + lastWord + '</span>';
    h1.dataset.dmkItalicized = '1';
  }

  function injectCollectionProofStrip() {
    if (document.querySelector('.dmk-product-proof-strip')) return;
    var sections = document.querySelectorAll('main .shopify-section');
    var lastSection = sections[sections.length - 1];
    if (!lastSection) return;
    var strip = document.createElement('div');
    strip.className = 'dmk-product-proof-strip';
    strip.innerHTML = ''
      + '<div class="dmk-proof-item"><span class="dmk-proof-stars">★★★★★</span> <span><strong>4.8</strong> from <strong>1,400+</strong> Etsy reviews</span></div>'
      + '<div class="dmk-proof-divider"></div>'
      + '<div class="dmk-proof-item"><span class="dmk-proof-mark">⚜</span> <span><span class="dmk-proof-italic">Hand-knit,</span> never machine-made</span></div>'
      + '<div class="dmk-proof-divider"></div>'
      + '<div class="dmk-proof-item"><span class="dmk-proof-mark">⛰</span> <span>From <span class="dmk-proof-italic">Daly Village,</span> Türkiye</span></div>';
    lastSection.parentNode.insertBefore(strip, lastSection.nextSibling);
  }

  function removeFloatingCTA() {
    document.querySelectorAll('.dmk-floating-cta').forEach(function(el) { el.remove(); });
  }

  function bindHeroParallax() {
    var hero = document.querySelector('.shopify-section[id*="slideshow_hero"]');
    if (!hero) return;
    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var scroll = Math.max(0, -rect.top);
      var max = rect.height;
      var clamped = Math.min(scroll, max);
      hero.style.setProperty('--dmk-hero-scroll', clamped + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function makeCollectionTitlesClickable() {
    var items = document.querySelectorAll('.dmk-tpl-index .resource-list__item');
    items.forEach(function(item) {
      if (item.classList.contains('dmk-clickable-card')) return;
      var anchor = item.querySelector('a[href*="/collections/"]');
      if (!anchor) return;
      var href = anchor.getAttribute('href');
      var titleEl = item.querySelector('collection-title, .collection-title');
      if (!titleEl) return;
      if (!titleEl.querySelector('a')) {
        var newLink = document.createElement('a');
        newLink.href = href;
        newLink.className = 'dmk-title-link';
        newLink.setAttribute('aria-label', 'Shop ' + (titleEl.textContent || 'collection').trim());
        while (titleEl.firstChild) newLink.appendChild(titleEl.firstChild);
        titleEl.appendChild(newLink);
      }
      item.classList.add('dmk-clickable-card');
    });
  }

  function isAlwaysVisibleSection(el) {
    if (!el) return false;
    if (el.classList.contains('section-dmk-photo-wall')) return true;
    if (el.querySelector && el.querySelector('.dmk-wall')) return true;
    return false;
  }

  function attach() {
    var tpl = tagBody();
    removeFloatingCTA();

    document.querySelectorAll('main .shopify-section').forEach(function(el, i) {
      if (el.classList.contains('dmk-fade-in') || el.classList.contains('dmk-in-view')) return;
      if (isAlwaysVisibleSection(el)) { el.classList.add('dmk-in-view'); return; }
      if (i === 0) { el.classList.add('dmk-in-view'); return; }
      el.classList.add('dmk-fade-in');
      sectionObserver.observe(el);
    });

    setTimeout(function() {
      document.querySelectorAll('main .shopify-section.dmk-fade-in:not(.dmk-in-view)').forEach(function(el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) el.classList.add('dmk-in-view');
      });
    }, 1800);

    ['.section-resource-list__content > .resource-list', 'main .shopify-section .product-grid', 'main .shopify-section .resource-list'].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(grid) {
        if (grid.classList.contains('dmk-stagger')) return;
        if (grid.children.length < 2) return;
        grid.classList.add('dmk-stagger');
        staggerObserver.observe(grid);
      });
    });

    if (tpl === 'index') {
      injectStatsBand();
      injectHandKnitPromise();
      bindHeroParallax();
      makeCollectionTitlesClickable();
    }
    if (tpl === 'product') {
      injectPreparationBadge();
      injectProductHandKnitBadge();
      injectProductProofStrip();
    }
    if (tpl === 'collection' || tpl === 'list-collections') {
      italicizeLastWord();
      injectCollectionProofStrip();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:select', attach);
})();
